import { PropsWithChildren } from 'react'

export const MainContent = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex flex-col gap-24 min-w-0 px-8 pb-8 md:px-24 md:pb-24">
      {children}
    </div>
  )
}
